import React, { useState } from 'react';
import "./pdfReader.scss"
import ClosePopupBtn from 'components/buttons/closePopupBtn';
import { Document, Page, pdfjs  } from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`
export default function PdfReader(props) {
    const {file, close, setCounter, counterDefault, drive} = props
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
        setPageNumber(1);
    }
    function changePage(offset) {
        setPageNumber(prevPageNumber => prevPageNumber + offset);
    }
    function previousPage() {
        setCounter(counterDefault)
        changePage(-1);
    }
    function nextPage() {
        setCounter(counterDefault)
        changePage(1);
    }
    return (
        <div id="pdfReader">
            <Document 
                file={drive ? "/pdf/" + file + ".pdf" : ("pdf/" + file)}
                // file={file}
                onLoadSuccess={onDocumentLoadSuccess}            
                onLoadError={error => console.log(error)}
                loading={"Chargement en cours"}
                error={<div>Impossible de charger le PDF</div>}
                
            >
                <Page
                    pageNumber={pageNumber} 
                    scale={1.5}
                />
            </Document>
            {
                numPages > 1 && 
                    <div className="pdfControls flex column around">
                        <p>
                            Page {pageNumber || (numPages ? 1 : '--')} / {numPages || '--'}
                        </p>
                        <div>
                            <button
                                type="button"
                                disabled={pageNumber <= 1}
                                onClick={previousPage}
                            >
                            {"<"} Précédent 
                            </button>
                                &nbsp; | &nbsp; 
                            <button
                                type="button"
                                disabled={pageNumber >= numPages}
                                onClick={nextPage}
                            >
                                Suivant  {">"}
                            </button>
                        </div> 
                    </div>
            }
            {
                !drive && <ClosePopupBtn close={close}/>
            }
            
        </div>
    );
}